import {
	IActionReviewPayload,
	IMyApprovalTableDataElements,
} from '../api/type-def';

export interface IMyApprovalTabsData {
	pendingTab: IMyapprovalTabDetails;
	approvedTab: IMyapprovalTabDetails;
	rejectedTab: IMyapprovalTabDetails;
}

export interface IMyapprovalTabDetails {
	data: IMyApprovalTableDataElements[];
	count: number;
}

export const defaultTabValues: IMyApprovalTabsData = {
	pendingTab: { data: [], count: 0 },
	approvedTab: { data: [], count: 0 },
	rejectedTab: { data: [], count: 0 },
};

export interface ChangeItemProps {
	changeObject: IActionReviewPayload;
	entityId: string;
	entityType: string;
	entityName: string;
	isChangesSubmitted: boolean;
	isApprovedChanges: boolean;
	shouldAbleToChangeApproval: boolean;
	submitChangesHandler: (
		action: string,
		id: string,
		isSubmitted: boolean,
		comment: string,
		dueDate: string,
		priority: string,
		status: string,
		createdDate: string,
		createdBy: string,
		shouldAbleToChangeApproval: boolean,
	) => void;
}

export interface IApproveViewProps {
	comment: string;
	timestamp: string;
	reviewer: string;
	status: string;
	priority: string;
	dueDate: string;
}

export interface IApprovalIconsProps {
	title: string;
	actionType: string;
	isApproved: boolean;
	isRejected: boolean;
	oldContent: string;
	newContent: string;
	timestamp: string;
	user: string;
	handleApprove: any;
	handleReject: any;
	shouldAbleToChangeApproval: boolean;
	loggedInUser: string;
	requestedUser: string;
}

export interface IOverviewProps {
	entityId: string;
	entityType: string;
	entityName?: string;
}

export enum TAB_NAMES {
	PENDING_TAB = 'Pending',
	APPROVED_TAB = 'Approved',
	REJECTED_TAB = 'Rejected',
	CHANGE_REQUEST = 'Request change',
	OVERVIEW_TAB = 'Overview',
	CHANGES_TAB = 'Changes',
}

export enum ACTION_VALUES {
	APPROVE = 'approve',
	REJECT = 'reject',
}

export enum REJECT_OPTION_VALUES {
	REJECT_CHANGES = 'reject',
	REQUEST_CHANGES = 'requestChanges',
}

export enum OPTION_VALUES {
	APPROVE_VALUES = 'Approved',
	REJECT_VALUES = 'Rejected',
	REQUEST_CHANGES_VALUES = 'Request change',
	PENDING = 'Pending',
	CHANGE_REQUESTED = 'Change requested',
}

export const SAVE_SUCCESS_MESSAGE = 'Details submitted successfully';
export const SAVE_FAILURE_MESSAGE = 'Unable to save details';
export const STATUS = 'Need revisions';
export const OBJECT_TYPE = 'Audit';
export const TASK_TYPE = 'Task';
export const REQUEST_CHANGE_API_KEY = 'Request change';
export const CANNOT_SAVE_MESSAGE = `Requested user can't approve/reject changes`;
